const Annotation = {
    elemName: '注釈',
    type: 'inline',
    doc: '翻刻時の疑問点などの注釈情報をタグ付けします。',
    example: '【このようにして注釈を書きます】',
    minContentCount: 1,
    maxContentCount: 1,
    textTemplate: '{{$text}}',
    htmlTemplate: `<span {{{$htmlId}}} class="Annotation {{$classes}}">【{{{$1}}}】</span>`,
    xmlTemplate: `<!-- {{$1}} -->`,
    docxTemplate: `<w:r>
                <w:rPr>
                    <w:rFonts w:hint="eastAsia"/>
                    <w:color w:val="FF0000"/>
                </w:rPr>
                <w:t>【{{{$$1}}}】</w:t>
            </w:r>`,
    latexTemplate: `\\textcolor{red}{【{{{$1}}}】}`
};
export default Annotation;
// import { KojiASTNode } from '../../KojiAstBuilder';
// import { ConversionRule } from '../ConversionRule';
// export default class Annotation extends ConversionRule {
// 	get elemName() {
// 		return '注釈';
// 	}
// 	toXML(node: KojiASTNode): string {
// 		const children = this.convertChildren(node.children);
// 		return `<!-- ${children} -->`;
// 	}
// 	toText(node: KojiASTNode): string {
// 		const text = this.converter.convertChildren(node.children);
// 		return `【${text}】`;
// 	}
// 	toHTML(node: KojiASTNode) {
// 		const text = this.convertChildren(node.children);
// 		return `<span class="Annotation inline" >【${text}】</span>`;
// 	}
// }
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQW5ub3RhdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb252ZXJ0ZXIvaW5saW5lX3J1bGVzL0Fubm90YXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxVQUFVLEdBQW1CO0lBQ2xDLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLFFBQVE7SUFDZCxHQUFHLEVBQUUseUJBQXlCO0lBQzlCLE9BQU8sRUFBRSxrQkFBa0I7SUFDM0IsZUFBZSxFQUFFLENBQUM7SUFDbEIsZUFBZSxFQUFFLENBQUM7SUFDbEIsWUFBWSxFQUFFLFdBQVc7SUFDekIsWUFBWSxFQUFFLHVFQUF1RTtJQUNyRixXQUFXLEVBQUUsaUJBQWlCO0lBQzlCLFlBQVksRUFBRTs7Ozs7O21CQU1JO0lBQ2xCLGFBQWEsRUFBRSw4QkFBOEI7Q0FDN0MsQ0FBQztBQUVGLGVBQWUsVUFBVSxDQUFDO0FBRTFCLHNEQUFzRDtBQUN0RCxzREFBc0Q7QUFFdEQsMkRBQTJEO0FBQzNELG9CQUFvQjtBQUNwQixpQkFBaUI7QUFDakIsS0FBSztBQUVMLHNDQUFzQztBQUN0QywwREFBMEQ7QUFDMUQsbUNBQW1DO0FBQ25DLEtBQUs7QUFFTCx1Q0FBdUM7QUFDdkMsZ0VBQWdFO0FBQ2hFLHdCQUF3QjtBQUN4QixLQUFLO0FBRUwsK0JBQStCO0FBQy9CLHNEQUFzRDtBQUN0RCxnRUFBZ0U7QUFDaEUsS0FBSztBQUNMLElBQUkifQ==